<template>
    <div>
        <!-- lander section -->
        <section class="section">
            <div class="container-fliud">
                <img alt="Vue logo" class="rounded-circle" height="200px" src="https://live.staticflickr.com/65535/50634131907_157386ae7c_k.jpg">
                <h1>Data Visualization Specialist</h1>
                <p>My name is Dylan Molnar and I am a data visualization specialist at Maxar. I specialize in telling complex stories visually.<br><br>email me at dylanlmolnar[at]gmail[dot]com</p>
                <!-- <button type="button" class="btn btn-outline-secondary btn-lg" data-toggle="modal" data-target=".bd-example-modal-lg">Contact</button> -->
                
            </div>
        </section>

        <!-- portfolio section -->
        <section class="portfolio">
            <h1>Interactive Portfolio</h1>
            <p>Here are a few recent projects I have contributed to</p>
            <div class="container">
                <div class="row">

                    <div class="col-md-4">
                            <div class="card">
                                <div class="card-head">
                                    <img alt="Vue logo" class="rounded-circle img-custome" src="https://live.staticflickr.com/65535/50634331793_bdb7480259_t.jpg">
                                    <h2>Enriching <br>Maps</h2>
                                </div>
                                <hr>
                                <div class="card-body">
                                    <p>
                                        This is an interactive story map showing various Maxar products.
                                        I can add more info here.<br>
                                        <i>Tools used: Mapbox, ERDAS, ArcGIS, JS, HTML, CSS.</i>
                                    </p>
                                    <button  type="button" class="btn btn-outline-secondary" onclick="location.href='https://mapping.maxar.com/enriching-maps/'">Check this out!</button>
                                </div>
                            </div>
                            <br>
                    </div>

                    <div class="col-md-4">
                            <div class="card">
                                <div class="card-head">
                                    <img alt="Vue logo" class="rounded-circle img-custome" src="https://live.staticflickr.com/65535/50634290543_05632e6907_t.jpg">
                                    <h2>Detecting <br>Deforestation</h2>
                                </div>
                                <hr>
                                <div class="card-body">
                                    <p>
                                        See how Maxar mapping products are used to detect and monitor illegal gold mining in Peru. <br>
                                        <i>Tools used: Mapbox, ERDAS, ArcGIS Pro, JS, HTML, CSS.</i>
                                    </p>
                                    <button type="button" class="btn btn-outline-secondary" onclick="location.href=''">Check it out!</button>
                                </div>
                            </div>
                        <br>
                    </div>  

                    <div class="col-md-4">
                        <div class="card">
                            <div class="card-head">
                                <img alt="Vue logo" class="rounded-circle img-custome" src="https://live.staticflickr.com/65535/50634290553_dc373ea449_t.jpg"> 
                                <h2>Infectious Disease Response</h2>
                            </div>
                            <hr>
                            <div class="card-body">
                                <p>
                                    Maxar enables Infectious disease planning with geospatial data, a modern approach to monitoring, preventing and predicting outbreaks at scale. <br>
                                    <i>Tools used: Mapbox, ERDAS, ArcGIS Pro, JS, HTML, CSS.</i>
                                </p>
                                <button type="button" class="btn btn-outline-secondary" onclick="location.href='https://explore.maxar.com/emergency-response'">Check it out!</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- modal for contact -->
        
        <section class="">
            <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <talk/>
                    </div>
                </div>
            </div>
        </section>
        
    </div>
</template>

<script lang="ts">
import talk from './Contact.vue'
export default {
    name:'Lander',
    components:{
        talk
    }  
}

</script>

<style lang="css" scoped>
    .btn-custom{
        background-color: #d1d1d1;
        border-color: #d1d1d1;
    }
    .section{
        padding-top: 10%;
        padding-bottom: 10%;
    }

    .portfolio{
        background-color: #cecece38;
        padding-top: 8%;
        padding-bottom: 15%;
        /* padding:15% */
    }

    .img-custome{
        width: 140px;
        height: 140px;
        margin-top: 15px;
    }

</style>